import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileHeader from './MobileHeader';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  // 비회원과 일반 유저는 데스크탑에서 사이드바 표시하지 않음
  const shouldShowSidebar = false;

  return (
    <div className="layout">
      {/* 비회원/일반 유저는 모바일에서만 사이드바 사용 */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className={`layout-main ${!shouldShowSidebar ? 'no-sidebar' : ''}`}>
        {/* 데스크탑 헤더 */}
        <Header onMenuClick={toggleSidebar} />

        {/* 모바일 헤더 */}
        <MobileHeader onMenuClick={toggleSidebar} />

        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default PublicLayout; 